/* PDP Related 2026 — mobile centered carousel via tiny-slider (tns global
   from the header). On desktop the slide count (4) does not exceed the
   visible items, so tns disables itself and the row renders static —
   exactly the Figma layout. Scoped per section instance. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pdp-related-slider]').forEach(function (root) {
    var container = root.querySelector('.pdp-related-2026__slider');
    if (!container || container.classList.contains('tns-slider')) return;
    if (typeof tns === 'undefined' || !container.children.length) return;

    /* Whole items + symmetric edgePadding = centered active card on mobile
       (card 298 + gutter 21 on 393: edgePadding 47). */
    var slider = tns({
      container: container,
      items: 1,
      slideBy: 1,
      startIndex: 0,
      nav: false,
      controls: false,
      gutter: 21,
      edgePadding: 47,
      autoplay: false,
      loop: true,
      rewind: false,
      mouseDrag: true,
      touch: true,
      preventScrollOnTouch: 'force',
      swipeAngle: false,
      responsive: {
        480: { edgePadding: 70 },
        768: { items: 3, gutter: 24, edgePadding: 60 },
        1024: { items: 4, gutter: 25, edgePadding: 0 }
      }
    });

    /* Custom dots (mobile only via CSS), same pattern as pdp-recipes-2026 */
    var dotsContainer = root.querySelector('.pdp-related-2026__dots');
    if (!dotsContainer || dotsContainer.getAttribute('data-show-nav') !== 'true') return;

    var info = slider.getInfo ? slider.getInfo() : null;
    if (!info) return;
    var slideCount = info.slideCount;
    if (slideCount < 2) return;

    var navContainer = document.createElement('div');
    navContainer.className = 'tns-nav custom-nav';

    for (var i = 0; i < slideCount; i++) {
      var button = document.createElement('button');
      button.setAttribute('data-nav', i);
      button.setAttribute('aria-label', 'Slide ' + (i + 1));
      button.type = 'button';
      if (i === 0) button.classList.add('tns-nav-active');
      navContainer.appendChild(button);
    }

    dotsContainer.appendChild(navContainer);

    slider.events.on('indexChanged', function (info) {
      var realIndex = (info.displayIndex - 1) % slideCount;
      navContainer.querySelectorAll('button').forEach(function (btn, idx) {
        btn.classList.toggle('tns-nav-active', idx === realIndex);
      });
    });

    navContainer.addEventListener('click', function (e) {
      if (e.target.tagName === 'BUTTON') {
        slider.goTo(parseInt(e.target.getAttribute('data-nav'), 10));
      }
    });
  });
});
